<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_v">Contents</a></h2><a id="page_v">
</a><p class="toc"><a id="page_v"></a><a class="nounder" href="#/xhtml/fore#fore"><em>Foreword, by Rick Shine</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/pref#pref"><em>Preface</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ack#ack"><em>Acknowledgments</em></a><br/><br/></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch01#ch01">1 <span class="red">•</span> Introduction</a></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2 <span class="red">•</span> Form and Function</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 <span class="red">•</span> A Day in the Life of a Snake</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 <span class="red">•</span> A Year in the Life of a Snake</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 <span class="red">•</span> Snake Sex</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 <span class="red">•</span> Snake Food</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 <span class="red">•</span> Snake Eaters</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 <span class="red">•</span> Snake Defense</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 <span class="red">•</span> Dangerous Snakes</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10 <span class="red">•</span> Snake Invaders</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11 <span class="red">•</span> Snake Conservation</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/epi#epi" title="Link target outside of Sample">Epilogue</span><br/><br/></p>
<p class="toc"><span class="nounder" href="#/xhtml/ref#ref" title="Link target outside of Sample"><em>References</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6b98add4